module.exports = __webpack_public_path__ + "static/colaboradores-05-afc49692d7d7ed0085ab4e199634dbc9.png";